import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'

const Banner = ({ title, image }) =>
  <Wrapper image={ image }>
    <Overlay>
      <Title dangerouslySetInnerHTML={{ __html: title }} />
    </Overlay>
  </Wrapper>

Banner.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string
}

export default Banner

const Wrapper = styled.div`
  background: ${props => `url(${props.image})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 300px;
`

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: end;
`

const Title = styled.h1`
  color: ${Theme.colors.white};
  text-transform: uppercase;
  ${Mixin.font.GothamBold(40, 600, 40)}
  margin: 0;
`
